//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/NXObject.js";
let d=[[],[[[],"GetFilterType",{R_:{filter_type:''}},0,0],[["n_components"],"GetComponents",{R_:{components:"Assemblies.Component[]"}},0,0],[["components"],"SetComponents",{},1,0],[[],"GetComponentMethod",{R_:{component_method:''}},0,0],[["component_method"],"SetComponentMethod",{},1,0],[["view"],"ApplyToView",{},1,0],[["view"],"RemoveFromView",{},1,0],[["n_views"],"GetAppliedViews",{R_:{views:"View[]"}},0,0],[["view","enabled"],"EnableInView",{},2,0],[[],"Copy",{R_:{filter_copy:"Annotations.PmiFilter"}},0,0],[["view"],"IsEnabled",{R_:{is_enabled:''}},1,0],[[],"UpdatePmiDisplay",{},0,0]],[]];
SPLM.Annotations.PmiFilter = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiFilter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.PmiFilter.FilterType = Object.freeze({
    "ByType" : "ByType", "ByView" : "ByView", "ByComponent" : "ByComponent"});

SPLM.Annotations.PmiFilter.ComponentMethod = Object.freeze({
    "Selected" : "Selected", "SelectedAndChildren" : "SelectedAndChildren", "All" : "All"});

export default SPLM;